/*
  Sister & Sewn: Founding Collection order rules (storefront layer)
  - Fabric yardage: minimum 2 yards
  - Wallpaper yardage: minimum 5 linear yards, 1-yard steps; rolls print up to 20 yards
  - Samples: exempt from yardage minimums; limited to SAMPLE_LIMIT per order
  This is a storefront guard only. Checkout-level enforcement needs a Shopify
  cart and checkout validation function (see audit report).
*/
(function () {
  'use strict';

  var SAMPLE_LIMIT = 10;
  var FABRIC_MIN = 2;
  var WALLPAPER_MIN = 5;
  var ROLL_YARDS = 20;
  var nativeFetch = window.fetch.bind(window);

  var MESSAGES = {
    fabric: 'Founding Collection fabric is sold with a 2-yard minimum per design and colorway.',
    wallpaper: 'Founding Collection wallpaper is sold with a 5 linear yard minimum per design and colorway.',
    sample: 'Sample orders are limited to ' + SAMPLE_LIMIT + ' samples. Please remove a sample before adding another.'
  };

  /* Classify a variant id using rules printed on product pages. */
  function ruleForId(id) {
    var map = window.ssVariantRules || {};
    return map[String(id || '')] || null;
  }

  /* Classify a cart line from /cart.js data. */
  function ruleForLine(item) {
    var known = ruleForId(item.variant_id);
    if (known) return known;
    var title = String(item.variant_title || '');
    var type = String(item.product_type || '');
    if (/sample/i.test(title)) return 'sample';
    if (/fabric by the yard/i.test(title)) return 'fabric';
    if (/by the (linear )?yard/i.test(title) && /wallpaper/i.test(type)) return 'wallpaper';
    return null;
  }

  function minFor(rule) {
    if (rule === 'fabric') return FABRIC_MIN;
    if (rule === 'wallpaper') return WALLPAPER_MIN;
    return 1;
  }

  function sampleCount(items) {
    return (items || []).reduce(function (n, item) {
      return n + (ruleForLine(item) === 'sample' ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  /* Returns null when the cart is valid, otherwise a rule key for the message. */
  function cartProblem(items) {
    for (var i = 0; i < (items || []).length; i++) {
      var item = items[i];
      var rule = ruleForLine(item);
      var qty = Number(item.quantity || 0);
      if ((rule === 'fabric' || rule === 'wallpaper') && qty > 0 && qty < minFor(rule)) return rule;
    }
    if (sampleCount(items) > SAMPLE_LIMIT) return 'sample';
    return null;
  }

  function announce(key, anchor) {
    var box = document.querySelector('[data-ss-sample-limit-message]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-ss-sample-limit-message', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #6B2334;color:#6B2334;background:#FAF4E8;font-size:13px;line-height:1.45;';
      (anchor || document.body).appendChild(box);
    }
    box.textContent = MESSAGES[key] || key;
    try { box.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }

  function jsonRefusal(key) {
    return new Response(JSON.stringify({ status: 422, message: MESSAGES[key], description: MESSAGES[key] }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function readBody(body) {
    if (!body) return {};
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var obj = {};
      body.forEach(function (value, key) { obj[key] = value; });
      return obj;
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) {
        var out = {};
        new URLSearchParams(body).forEach(function (value, key) { out[key] = value; });
        return out;
      }
    }
    return body;
  }

  /* Simulate the cart after the request and check it. */
  function projectAdd(data, cart) {
    var additions = Array.isArray(data.items) ? data.items : [{ id: data.id, quantity: data.quantity || 1 }];
    var items = (cart.items || []).map(function (i) { return Object.assign({}, i); });
    additions.forEach(function (add) {
      var id = String(add.id || '');
      var qty = Number(add.quantity || 1);
      var existing = items.find(function (i) { return String(i.variant_id) === id; });
      if (existing) existing.quantity = Number(existing.quantity) + qty;
      else items.push({ variant_id: id, quantity: qty, variant_title: ruleForId(id) === 'sample' ? 'Sample' : '' });
    });
    return cartProblem(items);
  }

  function projectChange(data, cart) {
    var items = (cart.items || []).map(function (i) { return Object.assign({}, i); });
    var line = Number(data.line || 0);
    if (!line && data.id != null) {
      line = items.findIndex(function (i) { return String(i.key) === String(data.id) || String(i.variant_id) === String(data.id); }) + 1;
    }
    if (line && items[line - 1]) items[line - 1].quantity = Number(data.quantity || 0);
    return cartProblem(items);
  }

  function projectUpdate(data, cart) {
    var updates = data.updates || {};
    var items = (cart.items || []).map(function (item, index) {
      var copy = Object.assign({}, item);
      var value = Array.isArray(updates) ? updates[index] : (updates[item.key] != null ? updates[item.key] : updates[item.variant_id]);
      if (value != null) copy.quantity = Number(value);
      return copy;
    });
    return cartProblem(items);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var match = url.match(/\/cart\/(add|change|update)(\.js)?(?:\?|$)/);
    if (!match) return nativeFetch(input, init);
    var action = match[1];
    var data = readBody(init && init.body);
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var problem = action === 'add' ? projectAdd(data, cart) : (action === 'change' ? projectChange(data, cart) : projectUpdate(data, cart));
        if (problem) {
          try { announce(problem, document.querySelector('form[action*="/cart"]')); } catch (e) {}
          return jsonRefusal(problem);
        }
        return nativeFetch(input, init).then(function (res) { setTimeout(checkCart, 300); return res; });
      })
      .catch(function () { return nativeFetch(input, init); });
  };

  /* Non-AJAX product form submits. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1 || form.dataset.ssApproved === 'true') return;
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var id = idField && idField.value;
    var rule = ruleForId(id);
    if (!rule) return;
    var qty = Number(qtyField && qtyField.value || 1);
    if ((rule === 'fabric' || rule === 'wallpaper') && qty < minFor(rule)) {
      event.preventDefault(); event.stopImmediatePropagation(); announce(rule, form); return;
    }
    if (rule !== 'sample') return;
    event.preventDefault(); event.stopImmediatePropagation();
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (sampleCount(cart.items) + qty > SAMPLE_LIMIT) { announce('sample', form); return; }
        form.dataset.ssApproved = 'true';
        if (form.requestSubmit) form.requestSubmit(event.submitter || undefined); else form.submit();
        setTimeout(function () { delete form.dataset.ssApproved; }, 1000);
      })
      .catch(function () { announce('We could not check the sample limit. Please refresh and try again.', form); });
  }, true);

  /* Cart page and drawer: block checkout while the cart breaks a rule. */
  var checking = false;
  function setCheckoutBlocked(problem) {
    var buttons = document.querySelectorAll('[name="checkout"], button[form][name="checkout"]');
    var express = document.querySelectorAll('.js-cart-footer-additional-buttons, .additional-checkout-buttons');
    buttons.forEach(function (b) {
      if (problem) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); }
      else if (b.getAttribute('aria-disabled') === 'true') { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); }
    });
    express.forEach(function (el) { el.style.display = problem ? 'none' : ''; });
    var notes = document.querySelectorAll('[data-ss-cart-rule-note]');
    var wanted = problem ? MESSAGES[problem] + ' Please update your cart to continue to checkout.' : '';
    var upToDate = problem
      ? (notes.length === buttons.length && Array.prototype.every.call(notes, function (n) { return n.textContent === wanted; }))
      : notes.length === 0;
    if (upToDate) return;
    notes.forEach(function (n) { n.remove(); });
    if (problem && buttons.length) {
      buttons.forEach(function (b) {
        var note = document.createElement('p');
        note.setAttribute('data-ss-cart-rule-note', '');
        note.setAttribute('role', 'alert');
        note.style.cssText = 'margin:10px 0;color:#6B2334;font-size:13px;line-height:1.45;';
        note.textContent = wanted;
        b.parentNode.insertBefore(note, b);
      });
    }
  }
  function checkCart() {
    if (checking) return;
    if (!document.querySelector('[name="checkout"]')) return;
    checking = true;
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCheckoutBlocked(cartProblem(cart.items)); })
      .catch(function () {})
      .then(function () { checking = false; });
  }
  var timer;
  function scheduleCheck() { clearTimeout(timer); timer = setTimeout(checkCart, 250); }
  document.addEventListener('DOMContentLoaded', scheduleCheck);
  if (document.readyState !== 'loading') scheduleCheck();
  try {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && t.closest('[data-ss-cart-rule-note], [data-ss-sample-limit-message]')) continue;
        scheduleCheck(); break;
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  /* Wallpaper roll count on product pages. */
  window.ssUpdateRollCount = function (scope) {
    var root = scope || document;
    var note = root.querySelector('[data-ss-roll-note]');
    if (!note) return;
    var input = root.querySelector('[data-quantity-input]');
    var out = note.querySelector('[data-ss-roll-count]');
    var qty = Number(input && input.value || 0);
    if (!out) return;
    if (qty > ROLL_YARDS) {
      var rolls = Math.ceil(qty / ROLL_YARDS);
      out.textContent = qty + ' yards will be printed as ' + rolls + ' rolls.';
    } else {
      out.textContent = '';
    }
  };
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-quantity-input]')) {
      window.ssUpdateRollCount(e.target.closest('form') || document);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-quantity-increase], [data-quantity-decrease]')) {
      setTimeout(function () { window.ssUpdateRollCount(e.target.closest('form') || document); }, 50);
    }
  });

  /* Variant switching on product pages: samples drop to 1, yardage returns to its minimum.
     The theme's quantity widget keeps its own count, so we change the number by
     pressing its own +/- buttons (keeps the widget in step) instead of writing the value. */
  function qtyInputFor(form) {
    if (!form) return null;
    return form.querySelector('[data-quantity-input][name="quantity"]') ||
      form.querySelector('[data-quantity-input]') ||
      Array.prototype.find.call(document.querySelectorAll('[data-quantity-input][name="quantity"]'), function (i) { return i.form === form; }) ||
      null;
  }
  function productFormFor(input) {
    if (!input) return null;
    if (input.form && /\/cart\/add/.test(input.form.getAttribute('action') || '')) return input.form;
    return input.closest ? input.closest('form[action*="/cart/add"]') : null;
  }
  function currentRule(form) {
    var idField = form && form.querySelector('[name="id"]');
    return ruleForId(idField && idField.value);
  }
  function widgetButton(input, which) {
    var wrap = input.closest('.product-quantity__wrapper') || input.closest('.product-quantity') || input.parentNode;
    return wrap && wrap.querySelector(which === 'up' ? '[data-quantity-increase]' : '[data-quantity-decrease]');
  }
  function stepTo(input, target) {
    var guard = 0;
    while (Number(input.value || 0) !== target && guard < 60) {
      var up = Number(input.value || 0) < target;
      var btn = widgetButton(input, up ? 'up' : 'down');
      if (!btn) break;
      var before = input.value;
      btn.removeAttribute('disabled'); btn.classList.remove('is-disabled');
      input.dataset.ssStepping = 'true';
      btn.click();
      delete input.dataset.ssStepping;
      if (input.value === before) break;
      guard++;
    }
    if (Number(input.value || 0) !== target) {
      input.value = target;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function updateRuleLabel(scope, min) {
    var rules = scope.querySelector('.js-product-quantity-rules');
    var minItem = scope.querySelector('.js-product-quantity-rule-min');
    var minVal = scope.querySelector('.js-product-quantity-rule-min-val');
    if (minVal) minVal.textContent = 'Minimum of ' + min;
    if (minItem) minItem.classList.toggle('is-hidden', min < 2);
    if (rules) rules.classList.toggle('is-hidden', min < 2);
  }
  function applyVariantQuantity(form) {
    if (!form) return;
    var rule = currentRule(form);
    if (!rule) return;
    var input = qtyInputFor(form);
    if (!input) return;
    var scope = input.closest('[data-section-type="product"]') || input.closest('.shopify-section') || form;
    var kind = rule === 'sample' ? 'sample' : 'yardage';
    var min = minFor(rule);
    input.setAttribute('min', 1);
    input.setAttribute('step', 1);
    if (input.dataset.ssLastKind && input.dataset.ssLastKind !== kind) stepTo(input, min);
    else if (Number(input.value || 0) < min) stepTo(input, min);
    input.dataset.ssLastKind = kind;
    var dec = widgetButton(input, 'down');
    if (dec) {
      var atMin = Number(input.value || 0) <= min;
      if (atMin) { dec.setAttribute('disabled', ''); } else { dec.removeAttribute('disabled'); dec.classList.remove('is-disabled'); }
    }
    updateRuleLabel(scope, min);
    var note = scope.querySelector('[data-ss-roll-note]');
    if (note) note.hidden = rule === 'sample';
    window.ssUpdateRollCount(scope);
  }
  function scheduleApply(form) {
    [80, 300, 800, 1500].forEach(function (ms) { setTimeout(function () { applyVariantQuantity(form); }, ms); });
  }
  /* Capture phase: the theme rebuilds the option buttons during its own change
     handler, which detaches the clicked radio from the form before a bubbling
     listener would see it. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || (t.matches && t.matches('[data-quantity-input]'))) return;
    var form = t.closest && t.closest('form[action*="/cart/add"]');
    if (!form && t.form && /\/cart\/add/.test(t.form.getAttribute('action') || '')) form = t.form;
    if (!form) return;
    scheduleApply(form);
  }, true);
  /* Yardage cannot go below its minimum; samples can go down to 1. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-quantity-decrease]');
    if (!btn) return;
    var wrap = btn.closest('.product-quantity__wrapper') || btn.closest('.product-quantity') || btn.parentNode;
    var input = wrap && wrap.querySelector('[data-quantity-input][name="quantity"]');
    if (!input || input.dataset.ssStepping === 'true') return;
    var form = productFormFor(input);
    var rule = currentRule(form);
    if (rule !== 'fabric' && rule !== 'wallpaper') return;
    if (Number(input.value || 0) <= minFor(rule)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-quantity-input][name="quantity"]') || input.dataset.ssStepping === 'true') return;
    var form = productFormFor(input);
    var rule = currentRule(form);
    if ((rule === 'fabric' || rule === 'wallpaper') && Number(input.value || 0) < minFor(rule)) {
      setTimeout(function () { stepTo(input, minFor(rule)); announce(rule, form); }, 0);
    }
  }, true);
  function initForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) { applyVariantQuantity(f); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initForms); else setTimeout(initForms, 0);
})();
